import { AppHeader } from '@profylr/ui'

import darkIcon from '@/assets/dark_icon_transparent_background.svg'
import { detectEnvironment, getEnvironmentConfig } from '@/config/environmentBranding'

interface HeaderProps {
  onMobileMenuToggle: () => void
}

/**
 * The application header, now a thin adapter over AppHeader from @profylr/ui.
 *
 * Everything it used to carry on the right -- the welcome message, the settings
 * toggle and the user menu -- has moved to the foot of the navigation rail. The
 * header answers "whose instance, which product"; account controls are neither,
 * and keeping them out is what stops it drifting back into a row of unrelated
 * icons.
 */
export default function Header({ onMobileMenuToggle }: HeaderProps) {
  const env = getEnvironmentConfig()
  const isProduction = detectEnvironment() === 'production'

  return (
    <AppHeader
      /*
       * The left slot is whose instance this is. Operational Resilience has no
       * per-tenant logo yet, so outside production it names the environment --
       * the same pattern Consumer Duty uses, where a configured tenant logo
       * takes this slot and the environment name fills in when there is none.
       *
       * Production shows nothing here: the absence is the signal.
       */
      identity={isProduction ? undefined : <span>{env.shortLabel}</span>}
      productMark={<img src={darkIcon} alt="" />}
      product="Operational Resilience"
      onMenuToggle={onMobileMenuToggle}
    />
  )
}
